import React from 'react';
import styles from './full-width-media.module.css';
import { FullWidthMedia as FullWidthMediaProp } from '../../typescript/component';
import WistiaVideo from './wistia-video';
import { getStaticOrAsset } from '../../helper/staticFiles';
import { getCachedAsset } from '../../helper/utils';

export default function FullWidthMedia({
  full_width_media,
}: {
  full_width_media: FullWidthMediaProp;
}) {
  const isVideo = (filename: string) => {
    return /\.(mp4|webm|ogg)$/i.test(filename);
  };

  const appendWidthParam = (url: string, width: number) => {
    try {
      const urlObj = new URL(url);
      urlObj.searchParams.set('width', width.toString());
      return urlObj.toString();
    } catch (error) {
      console.error('Invalid URL:', error);
      return url;
    }
  };
  return (
    <>
      {full_width_media && full_width_media.media ? (
        <div className={styles.wrapper}>
          {isVideo(full_width_media.media.filename) ? (
            <video
              autoPlay
              muted
              loop
              playsInline
              aria-hidden="true"
              data-noindex="true"
              aria-label="Background video"
              className={styles.backgroundMedia}
              key={full_width_media.media.url}
            >
              <source src={getCachedAsset(full_width_media.media.url)} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img
              src={appendWidthParam(getCachedAsset(full_width_media.media?.url) || '', 1440)}
              alt={full_width_media.media?.description}
              className={styles.backgroundMedia}
              width={1440}
              height={600}
              key={full_width_media.media?.url}
              aria-hidden="true"
              data-noindex="true"
              aria-label="Background image"
              style={{ width: '100%', height: 'auto', aspectRatio: '12/5' }}
            />
          )}
        </div>
      ) : (
        full_width_media?.wistia && (
          <div className={styles.wrapper}>
            <WistiaVideo
              embedUrl={full_width_media.wistia}
              responsive={true}
              key={full_width_media.wistia}
            />
          </div>
        )
      )}
    </>
  );
}
